/**
 * Created by yunanw on 17/12/3.
 */
import moment from 'moment'
export default (datetime) => {
  return moment(datetime).format('YYYY年MM月DD日')
}



// WEBPACK FOOTER //
// ./src/filters/dateFormat.js